export const ITEM_PER_PAGE = 10;
export const PAGE = 1;